<template>
  <div id="contenedor-eliminar-fuente-financiera">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Fuente Financiera </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la fuente financiera "{{fuenteFinancieraEliminar.nombre}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarFuenteFinanciera"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoFuentesFinancieras from './mixCatalogoFuentesFinancieras';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosFuentesfinancierasEliminar',
  mixins: [mixCatalogoFuentesFinancieras],
  props: {
    fuenteFinancieraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
